import { render, staticRenderFns } from "./PointHistoryTable.vue?vue&type=template&id=bc08c372&scoped=true&"
import script from "./PointHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PointHistoryTable.vue?vue&type=script&lang=js&"
import style1 from "./PointHistoryTable.vue?vue&type=style&index=1&id=bc08c372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc08c372",
  null
  
)

export default component.exports